<template>
  <div>
    <div class="block full">
  <div class="block">
    <h3>Total: {{totalProcess}} procesos</h3>
  </div>
  <div class="row">
    <div class="col-sm-4">
  <button @click="openModal" class="btn btn-primary">Filtrar Proceso</button>
    </div>
    <div class="col-sm-4">
      <button class="btn btn-warning" @click="searchAllProjects">Remover filtros</button>
    </div>
    <div class="col-sm-4">
      <label>
				<div class="input-group">
					<input id="searchCandidateAssignment" type="search" v-model="search" class="form-control" placeholder="Buscar procesos por nombre" aria-controls="">
						<span class="input-group-addon">
							<i class="fa fa-search"></i>
						</span>
				</div>
			</label>
    </div>
  </div>
  <br>
  <br>
  <div class="table-responsive">
    <div class="" id="">
      <table class="table" id="projects">
        <thead>
          <tr>
            <th>Número de Proceso</th>
            <th>Empresa</th>
            <th>Fecha creación</th>
            <th>Nombre aspirante</th>
            <th>Cédula</th>
            <th>Estado tarea</th>
            <th>Proceso</th>
            <th>Tipo</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr class="" v-for="project in  Projects" :key="project.id">
              <td>{{project.id}}</td>
              <td>{{project.project_client_name}}</td>
              <td>{{project.created_at}}</td>
              <td>{{project.project_person_full_name}}</td>
              <td>{{project.person_id}}</td>
              <td>{{project.status_name}}</td>
              <td>{{project.project_type_name}}</td>
              <td>{{project.assignment_type_name}}</td>
              <td>
                <a class="btn btn-primary" :href="`/workers/work/${project.id}`">Editar</a>
              </td>
          </tr>
        </tbody>
      </table>
      <pagination v-model="currentPage" :totalPages="totalRows" :per-page="10" :records="totalProcess" @paginate="myCallback"></pagination>
    </div>
  </div>
</div>
<!--Modal-->
<div class="modal fade" id="modalFilter" tabindex="-1" ref="modalFilter" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Busqueda Avanzada</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table">
              <tbody>
                <tr>
                  <td><b>Cliente</b></td>
                  <td>
                    <AutocompleteLocal :model.sync="project.client_id" :items="clientsFromModel"/>
                  </td>
                </tr>
                <tr>
                  <td><b>Fecha de inicio:</b></td>
                  <td><input type="date" v-model="project.start_date" name="start_date" class="form-control" value=""></td>
                </tr>
              <!--  <tr>
                  <td><b>Fecha de fin:</b></td>
                  <td><input type="date" v-model="project.end_date" name="end_date" class="form-control" value=""></td>
                </tr> -->
                <tr>
                  <td><b>Identificador de proceso:</b></td>
                  <td><input type="text" v-model="project.id" name="id" class="form-control" value=""></td>
                </tr>
                <tr>
                  <td><b>Nombre:</b></td>
                  <td><input type="text" v-model="project.first_name" name="first_name" class="form-control" value=""></td>
                </tr>
                <tr>
                  <td><b>Apellidos:</b></td>
                  <td><input type="text" v-model="project.last_name" name="last_name" class="form-control" value=""></td>
                </tr>
                <tr>
                  <td><b>Documento:</b></td>
                  <td><input type="text" v-model="project.person_id" name="person_id" class="form-control" value=""></td>
                </tr>
              </tbody>
            </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="btnClose" data-dismiss="modal">Cerrar</button>
        <button type="button" @click="searchFiltered" class="btn btn-primary">Buscar procesos</button>
      </div>
    </div>
  </div>
</div>


  </div>
</template>

<script>
import AutocompleteLocal from './../../own/autocomplete-local.vue'
import axios from 'axios'
import VueSelect from 'vue-select'
export default {
  name:'MyFinishProcess',
  props:['clients'],
  data(){
    return{
      totalProcess:0,
      totalRows: 1,
      currentPage:1,
      process:0,
      path: '/workers/my_projects_report_data',
      mutation:'changeProjects',
      search:'',
      project:{}
    }
  },
  methods:{
    searchAllProjects(){
      axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      let path = '/workers/my_projects_report_data'
      axios({
        method:'get',
        url:path,
        data:{},
        headers:{
          'Content-Type': 'application/json'
        },
        responseType:'json'
      }).then(res=>{
        this.totalProcess = res.data[2]
        this.Projects = res.data[0]
        if(this.totalProcess % 10 > 0){
          this.totalRows =  Math.ceil(this.totalProcess / 10) 
        }else{
          this.totalRows = this.totalProcess / 10
        }
      })
    },
    myCallback(event){
      axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      let path = '/workers/my_projects_report_data/?page='+event
      axios({
        method:'get',
        url:path,
        data:{},
        headers:{
          'Content-Type': 'application/json'
        },
        responseType:'json'
      }).then(res=>{
        this.Projects = res.data[0]
      })
    },
    searchByName(path){
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
       axios({
        method:'get',
        url:path,
        data:{},
        headers:{
          'Content-Type': 'application/json'
        },
        responseType:'json'
      }).then(res=>{
        this.totalProcess = res.data[2]
        this.Projects = res.data[0]
        if(this.totalProcess % 10 > 0){
          this.totalRows =  Math.ceil(this.totalProcess / 10) 
        }else{
          this.totalRows = this.totalProcess / 10
        }
        document.getElementById('btnClose').click()
        this.project = {}
      })
    },
    searchFiltered(){
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      let path = '/workers/my_projects_report_data'

      if(this.project.client_id != undefined){
        if(path.includes('?')){
          path += "&client_id="+this.project.client_id
        }else{
          path += "?client_id="+this.project.client_id
        }
      }
      if(this.project.start_date != undefined){
        if(path.includes('?')){
          path += "&start_date="+this.project.start_date
        }else{
          path += "?start_date="+this.project.start_date
        }
      }
      if(this.project.end_date != undefined){
        if(path.includes('?')){
          path += "&end_date="+this.project.end_date.split("-").reverse().join("-")
        }else{
          path += "?end_date="+this.project.end_date.split("-").reverse().join("-")
        }
      }
      if(this.project.person_id != undefined){
        if(path.includes('?')){
          path += "&person_id="+this.project.person_id
        }else{
          path += "?person_id="+this.project.person_id
        }
      }
      if(this.project.first_name != undefined){
        if(path.includes('?')){
          path += "&first_name="+this.project.first_name
        }else{
          path += "?first_name="+this.project.first_name
        }
      }
      if(this.project.last_name){
        if(path.includes('?')){
          path += "&last_name="+this.project.last_name
        }else{
          path += "?last_name="+this.project.last_name
        }
      }
      if(this.project.id){
        if(path.includes('?')){
          path += "&id="+this.project.id
        }else{
          path += "?id="+this.project.id
        }
      }

      this.searchByName(path)
    },
    openModal() {
      $('#modalFilter').modal('show')
      setTimeout(()=>{
        document.querySelector("#modalFilter").classList.remove("fade")
      },150)
    },
    closeModal() {
      $('#modalFilter').modal('hidden')
    }
  },
  created(){
    this.searchAllProjects()
  },
  computed: {
    Projects:{
      get(){
        return this.$store.state.projects
      },
      set(val){
        this.$store.commit('changeProjects',val)
      }
    },
    clientsFromModel:{
      get(){
        return this.clients
      }
    }
  },
  watch:{
    search(val){
      if(val.length > 3){
        let path = '/workers/my_projects_report_data?full_name='+ val
        this.searchByName(path)
      }
    }
  },
  components:{
    'v-select':VueSelect,
    AutocompleteLocal
  }
}
</script>
<style>

</style>